"use client";

import AdminSidebar from "../../../components/AdminSidebar";
import { useState } from "react";
import { useRouter } from "next/navigation";

export default function NuevoVehiculo() {
  const router = useRouter();
  const [form, setForm] = useState({
    tipo:"Sprinter",
    marca:"",
    modelo:"",
    year:"",
    placa:"",
    vin:"",
    color:"",
    capacidad:"14",
    empresa:"",
    seguro:"",
    inspeccion:"",
    status:"Activo"
  });

  function update(field:string,value:string) {
    setForm({...form,[field]:value});
  }

  async function guardar(e:React.FormEvent) {
    e.preventDefault();

    const res = await fetch("/api/vehiculos", {
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify(form)
    });

    if (!res.ok) {
      alert("Error guardando vehículo");
      return;
    }

    router.push("/admin/vehiculos");
  }

  return (
    <main style={{minHeight:"100vh",background:"#050b18",color:"#fff",fontFamily:"sans-serif"}}>
      <AdminSidebar />

      <section style={{marginLeft:"260px",padding:"40px",maxWidth:"1100px"}}>
        <h1 style={{color:"#f5a623",fontSize:"32px",marginBottom:"6px"}}>Nuevo Vehículo</h1>
        <p style={{color:"#8ea0c4",marginBottom:"30px"}}>Registra un vehículo para operar rutas dentro de MiRutaUSA</p>

        <form onSubmit={guardar} style={card}>
          <Section title="🚐 Datos del Vehículo">
            <Grid>
              <Field label="Tipo de vehículo *">
                <select required style={input} value={form.tipo} onChange={e=>update("tipo",e.target.value)}>
                  <option>Sprinter</option>
                  <option>Van</option>
                  <option>Minibus</option>
                  <option>Bus</option>
                  <option>SUV</option>
                  <option>Sedan</option>
                </select>
              </Field>

              <Field label="Marca *">
                <input required style={input} value={form.marca} onChange={e=>update("marca",e.target.value)} placeholder="Mercedes-Benz" />
              </Field>

              <Field label="Modelo *">
                <input required style={input} value={form.modelo} onChange={e=>update("modelo",e.target.value)} placeholder="Sprinter 2500" />
              </Field>

              <Field label="Año">
                <input style={input} value={form.year} onChange={e=>update("year",e.target.value)} placeholder="2024" />
              </Field>

              <Field label="Placa *">
                <input required style={input} value={form.placa} onChange={e=>update("placa",e.target.value)} placeholder="NY-12345" />
              </Field>

              <Field label="VIN">
                <input style={input} value={form.vin} onChange={e=>update("vin",e.target.value)} placeholder="Número VIN" />
              </Field>

              <Field label="Color">
                <input style={input} value={form.color} onChange={e=>update("color",e.target.value)} placeholder="Negro" />
              </Field>

              <Field label="Capacidad de pasajeros *">
                <input required style={input} value={form.capacidad} onChange={e=>update("capacidad",e.target.value)} placeholder="14" />
              </Field>
            </Grid>
          </Section>

          <Section title="🏢 Empresa y Operación">
            <Grid>
              <Field label="Empresa asignada *">
                <input required style={input} value={form.empresa} onChange={e=>update("empresa",e.target.value)} placeholder="Latina Transit LLC" />
              </Field>

              <Field label="Estado operativo">
                <select style={input} value={form.status} onChange={e=>update("status",e.target.value)}>
                  <option>Activo</option>
                  <option>Inactivo</option>
                  <option>Mantenimiento</option>
                </select>
              </Field>
            </Grid>
          </Section>

          <Section title="🛡️ Documentación">
            <Grid>
              <Field label="Seguro / Policy Number">
                <input style={input} value={form.seguro} onChange={e=>update("seguro",e.target.value)} placeholder="INS-000000" />
              </Field>

              <Field label="Fecha de inspección">
                <input type="date" style={input} value={form.inspeccion} onChange={e=>update("inspeccion",e.target.value)} />
              </Field>
            </Grid>
          </Section>

          <div style={summary}>
            <h3 style={{marginTop:0,color:"#f5a623"}}>Resumen</h3>
            <p><b>Vehículo:</b> {form.marca || "—"} {form.modelo || ""}</p>
            <p><b>Tipo:</b> {form.tipo}</p>
            <p><b>Capacidad:</b> {form.capacidad} pasajeros</p>
            <p><b>Empresa:</b> {form.empresa || "—"}</p>
          </div>

          <div style={{display:"flex",gap:"14px",marginTop:"26px"}}>
            <button type="submit" style={button}>💾 Guardar Vehículo</button>
            <button type="button" onClick={()=>router.push("/admin/vehiculos")} style={cancel}>Cancelar</button>
          </div>
        </form>
      </section>
    </main>
  );
}

function Section({title,children}:any) {
  return (
    <div style={{marginBottom:"30px"}}>
      <h2 style={{fontSize:"18px",color:"#f5a623",marginBottom:"16px"}}>{title}</h2>
      {children}
    </div>
  );
}

function Grid({children}:any) {
  return <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:"18px"}}>{children}</div>;
}

function Field({label,children}:any) {
  return (
    <div>
      <label style={{display:"block",fontSize:"13px",color:"#b8c4e0",marginBottom:"7px"}}>{label}</label>
      {children}
    </div>
  );
}

const card={background:"#0f1d36",border:"1px solid #1a2744",borderRadius:"18px",padding:"30px"};
const input={width:"100%",padding:"13px",borderRadius:"10px",border:"1px solid #24324d",background:"#07111f",color:"#fff"};
const summary={background:"#07111f",border:"1px solid #24324d",borderRadius:"14px",padding:"20px",marginTop:"10px",color:"#d8e2ff"};
const button={background:"#f5a623",color:"#000",border:"none",padding:"14px 22px",borderRadius:"10px",fontWeight:"bold",cursor:"pointer"};
const cancel={background:"transparent",color:"#fff",border:"1px solid #24324d",padding:"14px 22px",borderRadius:"10px",fontWeight:"bold",cursor:"pointer"};
